<ul class="list">
  @for (item of list; track item) {
    <li class="d-flex me-5">
      <mat-checkbox [ngModel]="control.value && control.value.indexOf(item.value)>=0"
        (ngModelChange)="update($event,item.value)">
        {{item.text}}
      </mat-checkbox>
    </li>
  }
</ul>
